const openapi = [{
  desc: '点击统计',
  options: {
    url: '/clickrates',
    method: 'post',
    baseURL: '/openapi/api/preprice-car'
  },
  vuex: false
}, {
  desc: '获取用户登录地址',
  options: {
    url: '/cityjson',
    method: 'post',
    baseURL: '/sohu'
  }
}, {
  desc: '获取投保车牌省份',
  options: {
    url: '/natgeos/province',
    baseURL: '/openapi/api/preprice-car',
    method: 'get'
  }
}, {
  desc: '获取投保车牌省份',
  options: {
    url: '/natgeos/cityLicenceNo',
    baseURL: '/openapi/api/preprice-car',
    method: 'get',
    argsParams: true
  }
}]
export default openapi



// WEBPACK FOOTER //
// ./src/api/openapi.js